import { Pipe } from '@angular/core';

// Tell Angular2 we're creating a Pipe with TypeScript decorators
@Pipe({
    name: 'feedbackPipe'
})
export class FeedbackPipe {
    // Transform is the new "return function(value, args)" in Angular 1.x
    transform(value, args?) {
        // ES6 array destructuring
        let val;
        let str;
        let subActivity;
        let content;
        let membershipId;
        if (args) {
            args = args.toLowerCase();
            return value.filter(feedback => {
                subActivity = feedback.subActivity ? feedback.subActivity.toString().toLowerCase() : '';
                content = feedback.content ? feedback.content.toString().toLowerCase() : '';
                membershipId = feedback.membershipId ? (feedback.membershipId + '').toLowerCase():'';
                if (subActivity.indexOf(args) >= 0) {
                    return feedback;
                }
                if (content.indexOf(args) >= 0) {
                    return feedback;
                }
                if (membershipId.indexOf(args) >= 0) {
                    return feedback;
                }
            });
        }
        else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/feedback/feedback.search.ts